export default indexBanner => {
    let $indexBanner = $('.index-banner');

    if ($indexBanner.length < 1) {
        return false;
    }

    let $bannerElement = $('#banner');
    let banner = null;

    $.ajax({
        url: 'ajax/default-banner',
        success:
            function (data) {
                setData(data);
            }
    });

    function setData(data) {
        banner =  JSON.parse(data);
        showBanner();
    }

    function showBanner() {
        if (banner.length <= 1) {
            return;
        }

        banner.forEach(element => {
            switch(element.type) {
                case 'superbanner':
                    $('#sb_hl').text(element.headline);
                    $('#sb_ln').attr('href', element.link);
                    $('#sg_im').attr("src", '/uploads/images/banner/' + element.image);

                    break;
                case 'medium-rectangle':
                    $('#mr_hl').text(element.headline);
                    $('#mr_ln').attr('href', element.link);
                    $('#mr_im').attr("src", '/uploads/images/banner/' + element.image);

                    break;
            }
        });

        $bannerElement.show(200);
    }
}
